<template>
  <el-dialog
    title="修改面积"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <h3 class="m-t-none m-b">修改面积</h3>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="小区面积" prop="communityArea">
        <el-input
          v-model="form.communityArea"
          placeholder="必填，请填写小区面积"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="editCommunityArea">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateCommunityArea } from '@/api/common/enterCommunity/enterCommunityApi'

export default {
  name: 'EditCommunityArea',
  data() {
    return {
      dialogVisible: false,
      form: {
        communityId: '',
        communityArea: ''
      },
      rules: {
        communityArea: [
          { required: true, message: '小区面积不能为空', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '小区面积必须是3.00格式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(communityInfo) {
      this.form = {
        communityId: communityInfo.communityId,
        communityArea: communityInfo.communityArea
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    editCommunityArea() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        try {
          await updateCommunityArea(this.form)
          this.$emit('refresh')
          this.dialogVisible = false
          this.$message.success('修改成功')
        } catch (error) {
          console.error('修改面积失败:', error)
          this.$message.error('修改面积失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.m-t-none {
  margin-top: 0;
}
.m-b {
  margin-bottom: 20px;
}
</style>